export default [
  {
    path: "/",
    name: "foravila-home",
    component: () => import("@/views/home/Home.vue"),
    meta: {
      action: "manage",
      resource: "administration",
    },
  },
  {
    path: "/stats",
    name: "foravila-stats",
    component: () => import("@/views/stats/GeneralStats.vue"),
    meta: {
      action: "manage",
      resource: "all",
    }
  },
];
